import { last } from "lodash/fp";
import { DateTime, Info } from "luxon";

import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

/**
 * Extend the luxon adapter to move the start of the week from
 * Monday to Sunday and the end of the week from Sunday to Saturday.
 */
class AdapterLuxonCustom extends AdapterLuxon {
  public getWeekArray = (date: DateTime) => {
    // The week adjustment isn't needed here because
    // this function is calculating a diff between two dates
    // and the week offset cancels out
    const { days } = date
      .endOf("month")
      .endOf("week")
      .diff(date.startOf("month").startOf("week"), "days")
      .toObject();

    const weeks: DateTime[][] = [];
    new Array<number>(Math.round(days!))
      .fill(0)
      .map((_, i) => i)
      .map((day) =>
        date
          .startOf("month")
          .startOf("week")
          .minus({ day: 1 }) // offset the start of the week by 1
          .plus({ days: day }),
      )
      .forEach((v, i) => {
        if (i === 0 || (i % 7 === 0 && i > 6)) {
          weeks.push([v]);
          return;
        }

        weeks[weeks.length - 1].push(v);
      });
    return weeks;
  };

  public startOfWeek = (date: DateTime) => {
    // if the date is Sunday, then the start of the week is the same day
    // otherwise, subtract the weekday from the date for example if the weekday is 1 (Monday)
    // we would subtract 1 day from the date to get the start of the week which is Sunday
    // Keep in mind that luxon does 1 index the days of the week.
    const adjustDays = date.weekday === 7 ? 0 : date.weekday;
    return date.startOf("day").minus({ days: adjustDays });
  };

  public endOfWeek = (date: DateTime) => {
    return this.startOfWeek(date).plus({ days: 6 }).endOf("day");
  };

  public getWeekdays = () => {
    const weekdays = Info.weekdaysFormat("short", { locale: this.locale });
    return [last(weekdays) as string, ...weekdays.slice(1)];
  };
}

export default AdapterLuxonCustom;
